export default ({blob, type, name}) => {
    let newBlob = new Blob([blob], {type});

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
    }

    const data = window.URL.createObjectURL(newBlob);

    let link = document.createElement('a');
    link.href = data;

    switch (type) {
        case 'text/html':
            link.download = `${name}.html`;
            break;
        case 'application/pdf':
            link.download = `${name}.pdf`;
            break;
        default:
            link.download = name;
            break;
    }

    link.click();
};